export enum FEES {
  single_use_cup_fee = 'singleUseCup',
}
